import { withTranslation } from "react-i18next";

import LanguageSelect from './LanguageSelect';

export default withTranslation(undefined, { withRef: true })(LanguageSelect);